import { useEffect, useState } from "react";
import { GetCustomerDocuments, GetCustomerOnboardingDocuments, GetCustomerOnboardingDocumentsDocuments } from "../functions/http-functions/customer";
import { useAuth } from "../state/context/auth.store";
import { ApiResultModel } from "../_models/api.result.model";
import { RightToWorkItems as DefaultRightToWorkItems } from "../config/formData";

export interface RightToWorkItem {
	ID: number;
	Name: string;
	required?: boolean;
	hideFromOnboarding?: boolean;
	hasExpiry?: boolean;
	hasIssued?: boolean;
	hasLastChecked?: boolean;
}

export const useCustomerDocuments = () => {
	const { auth } = useAuth();
	const [RightToWorkAvailableItems, setRightToWorkItems] = useState<RightToWorkItem[]>([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const fetchDocuments = async () => {
			try {
				setIsLoading(true);
				const response = await GetCustomerDocuments(auth.token);
				const result = new ApiResultModel(response.data);

				const formattedDocuments = result.data.map((doc) => ({
					ID: doc.documentEnum,
					Name: doc.name,
					required: doc.required,
					hideFromOnboarding: doc.hideFromOnboarding,
					hasExpiry: doc.hasExpiry,
					hasIssued: doc.hasIssued,
					hasLastChecked: doc.hasLastChecked,
				}));

				setRightToWorkItems(formattedDocuments);
			} catch (err) {
				setRightToWorkItems(DefaultRightToWorkItems);
			} finally {
				setIsLoading(false);
			}
		};

		if (auth?.token) {
			fetchDocuments();
		}
	}, [auth?.token]);

	return { RightToWorkAvailableItems, isLoading };
};

export const useCustomerOnboardingDocuments = (token: string) => {
	const [RightToWorkAvailableItems, setRightToWorkItems] = useState<RightToWorkItem[]>([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const fetchDocuments = async () => {
			try {
				setIsLoading(true);
				const response = await GetCustomerOnboardingDocuments(token);
				const result = new ApiResultModel(response.data);

				const formattedDocuments = result.data.map((doc) => ({
					ID: doc.documentEnum,
					Name: doc.name,
					required: doc.required,
					hideFromOnboarding: doc.hideFromOnboarding,
					hasExpiry: doc.hasExpiry,
					hasIssued: doc.hasIssued,
					hasLastChecked: doc.hasLastChecked,
				}));

				setRightToWorkItems(formattedDocuments);
			} catch (err) {
				setRightToWorkItems(DefaultRightToWorkItems);
			} finally {
				setIsLoading(false);
			}
		};

		if (token) {
			fetchDocuments();
		}
	}, [token]);

	return { RightToWorkAvailableItems, isLoading };
};

export const useCustomerOnboardingDocumentsDocuments = (token: string) => {
	const [RightToWorkAvailableItems, setRightToWorkItems] = useState<RightToWorkItem[]>([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const fetchDocuments = async () => {
			try {
				setIsLoading(true);
				const response = await GetCustomerOnboardingDocumentsDocuments(token);
				const result = new ApiResultModel(response.data);

				const formattedDocuments = result.data.map((doc) => ({
					ID: doc.documentEnum,
					Name: doc.name,
					required: doc.required,
					hideFromOnboarding: doc.hideFromOnboarding,
					hasExpiry: doc.hasExpiry,
					hasIssued: doc.hasIssued,
					hasLastChecked: doc.hasLastChecked,
				}));

				setRightToWorkItems(formattedDocuments);
			} catch (err) {
				setRightToWorkItems(DefaultRightToWorkItems);
			} finally {
				setIsLoading(false);
			}
		};

		if (token) {
			fetchDocuments();
		}
	}, [token]);

	return { RightToWorkAvailableItems, isLoading };
};
